import { render, staticRenderFns } from "./MeEditorWebrtcVideo.vue?vue&type=template&id=4cc7ef3a&scoped=true&"
import script from "./MeEditorWebrtcVideo.vue?vue&type=script&lang=js&"
export * from "./MeEditorWebrtcVideo.vue?vue&type=script&lang=js&"
import style0 from "./MeEditorWebrtcVideo.vue?vue&type=style&index=0&id=4cc7ef3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc7ef3a",
  null
  
)

export default component.exports